/** Times as the Maker portal writes them: UTC, "12 Oct 09:31". */

const MONTHS = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"] as const;
const two = (n: number): string => String(n).padStart(2, "0");

function parse(iso: string | null | undefined): Date | null {
  if (iso === null || iso === undefined || iso === "") return null;
  const ms = Date.parse(iso);
  return Number.isNaN(ms) ? null : new Date(ms);
}

/** "12 Oct 09:31" (UTC); "—" for missing input. */
export function utcDayTime(iso: string | null | undefined): string {
  const d = parse(iso);
  return d === null ? "—" : `${d.getUTCDate()} ${MONTHS[d.getUTCMonth()]} ${two(d.getUTCHours())}:${two(d.getUTCMinutes())}`;
}

/** "09:31" (UTC). */
export function utcClock(iso: string | null | undefined): string {
  const d = parse(iso);
  return d === null ? "—" : `${two(d.getUTCHours())}:${two(d.getUTCMinutes())}`;
}

/** "09:40:30" (UTC). */
export function utcClockSeconds(iso: string | null | undefined): string {
  const d = parse(iso);
  return d === null ? "—" : `${two(d.getUTCHours())}:${two(d.getUTCMinutes())}:${two(d.getUTCSeconds())}`;
}

/** "09:31 UTC" on the day of `now`, else "11 Oct 09:31 UTC". */
export function utcStamp(iso: string | null | undefined, now: number = Date.now()): string {
  const d = parse(iso);
  if (d === null) return "—";
  const t = new Date(now);
  const sameDay = d.getUTCFullYear() === t.getUTCFullYear() && d.getUTCMonth() === t.getUTCMonth() && d.getUTCDate() === t.getUTCDate();
  return sameDay ? `${utcClock(iso)} UTC` : `${utcDayTime(iso)} UTC`;
}
